export default __webpack_public_path__ + "static/media/phoenix.26c1c9b0.svg";